/** Format call duration for operators: 45s · 4m 17s · 1h 2m 5s */
export function formatDuration(totalSeconds: number | null | undefined): string {
  const raw = Number(totalSeconds);
  if (!Number.isFinite(raw) || raw < 0) return '0s';
  const seconds = Math.floor(raw);
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  if (hours > 0) {
    return minutes > 0 || secs > 0
      ? `${hours}h ${minutes}m ${secs}s`
      : `${hours}h`;
  }
  if (minutes > 0) {
    return secs > 0 ? `${minutes}m ${secs}s` : `${minutes}m`;
  }
  return `${secs}s`;
}
